module.exports = __webpack_public_path__ + "img/ar-rounded.4df415cf.png";